import React, { useState, useEffect } from "react"
import { useHistory } from "react-router-dom"
import { Card, Menu, Button, Input, Dropdown } from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import i18next from "i18next"
import LoginComponent from "./LoginComponent"
import RegistrationComponent from "./RegistrationComponent"

const AuthorizationComponent = (props) => {
  const { type } = props
  const history = useHistory()
  const { t } = useTranslation()
  const [ecpEntry, setEcpEntry] = useState(false)
  const [lang, setLang] = useState("")
  useEffect(() => {
    if (localStorage.getItem("lang")) {
      let data = JSON.parse(localStorage.getItem("lang"))
      setLang(data[1])
      i18next.changeLanguage(data[0])
    } else {
      setLang("Рус")
    }
  }, [])
  const changeLang = (lang, textLang) => {
    setLang(textLang)
    i18next.changeLanguage(lang, () => {})
    localStorage.setItem("lang", JSON.stringify([lang, textLang]))
  }
  return (
    <>
      <div
        style={{
          minHeight: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Card style={{ minWidth: 400 }}>
          <Card.Header>
            <h1 style={{ margin: 10, display: "inline-block" }}>
              {t("Marking")}
            </h1>
            <div
              style={{
                display: type === "registration" ? "inline-block" : "flex",
                paddingLeft: 20,
                paddingBottom: 10,
              }}
            >
              <Menu
                style={{
                  boxShadow: "0 0 0",
                  width: "max-content",
                  display: "inline-block",
                }}
              >
                <Menu.Item as={Dropdown} pointing text={lang}>
                  <Dropdown.Menu>
                    <Dropdown.Item
                      content="Рус"
                      value="ru"
                      onClick={() => {
                        changeLang("ru", "Рус")
                      }}
                    />
                    <Dropdown.Item
                      content="Eng"
                      value="en"
                      onClick={() => {
                        changeLang("en", "Eng")
                      }}
                    />
                  </Dropdown.Menu>
                </Menu.Item>
              </Menu>
              <div>
                {type === "login" ? (
                  <>
                    <div style={{ marginLeft: 20 }}>
                      {true && (
                        <Button
                          content={
                            ecpEntry ? t("Enter by IIN") : t("Enter by ECP")
                          }
                          onClick={() => {
                            setEcpEntry(!ecpEntry)
                          }}
                          style={{
                            color: "black",
                            backgroundColor: "white",
                            border: "1px solid lightgray",
                            fontWeight: "100",
                            height: 42,
                          }}
                        />
                      )}
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </Card.Header>
          <Card.Content>
            {type === "login" ? (
              <>
                <div>
                  <LoginComponent ecpEntry={ecpEntry} />
                </div>
              </>
            ) : type === "registration" ? (
              <>
                <div>
                  <RegistrationComponent history={history} />
                </div>
              </>
            ) : (
              <></>
            )}
          </Card.Content>
        </Card>
      </div>
      <div style={{ height: 100 }}></div>
    </>
  )
}

export default AuthorizationComponent
